// Project constants
export const PROJECT_NAME = "Transport vending platform";
export const ADMIN_EMAIL = "info@interswitch.com";
export const COOKIES_TIME = 7;
export const NOTIFICATION_DURATION = 4;

// response
export const SUCCESSFUL_CODE = 200;

//Error message
export const FETCH_ERROR_MESSAGE = `Error!, unable to access the serve. Please try again`;

// Module constants
export const LOADING_MAIN = "LOADING_MAIN";
export const LOADING_MAIN_DONE = "LOADING_MAIN_DONE";
export const GLOBAL_FETCH_START = "GLOBAL_FETCH_START";
export const GLOBAL_FETCH_SUCCESS = "GLOBAL_FETCH_SUCCESS";
export const FETCH_START = "FETCH_START";
export const FETCH_ROUTE_LOADING = "FETCH_ROUTE_LOADING";
export const FETCH_ROUTE_SUCCESS = "FETCH_ROUTE_SUCCESS";
export const FETCH_SUCCESS = "FETCH_SUCCESS";
export const FETCH_ERROR = "FETCH_ERROR";
export const SHOW_MESSAGE = "SHOW_MESSAGE";
export const HIDE_MESSAGE = "HIDE_MESSAGE";
export const FETCH_ROUTE_DETAILS = "FETCH_ROUTE_DETAILS";
export const FETCH_TRANSPORT_ROUTE_DETAILS_SUCCESS =
  "FETCH_TRANSPORT_ROUTE_DETAILS_SUCCESS";

//permissions
export const SAVE_PERMISSION = "SAVE_PERMISSION";
export const LOADING_PERMISSION = "SAVE_USER_PERMISSION";
export const SAVE_USER_PERMISSION = "SAVE_USER_PERMISSION";

//operators
export const SAVE_OPERATORS = "SAVE_OPERATORS";
export const SAVE_OPERATORS_LIST = "SAVE_OPERATORS_LIST";
export const LOADING_OPERATORS = "SAVE_USER_OPERATORS";
export const LOADING_STATE = "LOADING_STATE";
export const LOADING_STATE_INNER = "LOADING_STATE_INNER";
export const SAVE_STATE = "SAVE_STATE";

//Admin
export const FETCH_ADMIN_START = "FETCH_ADMIN_START";
export const FETCH_ADMIN_END = "FETCH_ADMIN_END";
export const SAVE_ADMIN_START = "SAVE_ADMIN_START";
export const SAVE_ADMIN = "SAVE_ADMIN";
export const SAVE_ADMIN_PAGE = "SAVE_ADMIN_PAGE";

// roles
export const FETCH_ROLES_START = "FETCH_ROLES_START";
export const FETCH_ROLES_END = "FETCH_ROLES_END";
export const SAVE_ROLES_START = "SAVE_ROLES_START";
export const SAVE_ROLES = "SAVE_ROLES";

//Individuals
export const TEMP_CREATED_INDIVIDUAL_EMAIL = "TEMP_CREATED_INDIVIDUAL_EMAIL";
export const SAVE_INDIVIDUAL = "SAVE_INDIVIDUAL";
export const LOADING_DASHDOARD = "LOADING_DASHDOARD";
export const SAVE_DASHDOARD = "SAVE_DASHDOARD";

//Countries
export const SAVE_FETCH_COUNTRIES = "SAVE_FETCH_COUNTRIES";
export const FETCH_COUNTRIES = "FETCH_COUNTRIES";
export const FETCH_COUNTRIES_ERROR = FETCH_ERROR_MESSAGE;

//Auth const
export const SIGNUP_USER = "SIGNUP_USER";
export const SIGNUP_ERROR = "SIGNUP_ERROR";
export const SIGNIN_USER_SUCCESS = "SIGNIN_USER_SUCCESS";
export const SIGNUP_USER_SUCCESS = "SIGNUP_USER_SUCCESS";
export const SIGNIN_USER_NOT_ACTIVE = "SIGNIN_USER_NOT_ACTIVE";
export const SIGNOUT_USER_SUCCESS = "SIGNOUT_USER_SUCCESS";
export const ON_SHOW_LOADER = "ON_SHOW_LOADER";
export const ON_SHOW_LOADER_DONE = "ON_SHOW_LOADER_DONE";
export const USER_TOKEN_SET = "USER_TOKEN_SET";

//Transactions
export const FETCH_SYSTEM_TRANSACTION_START = "FETCH_SYSTEM_TRANSACTION_START";
export const FETCH_SYSTEM_TRANSACTION_END = "FETCH_SYSTEM_TRANSACTION_END";
export const SAVE_SYSTEM_TRANSACTION_START = "SAVE_SYSTEM_TRANSACTION_START";
export const SAVE_SYSTEM_TRANSACTION = "SAVE_SYSTEM_TRANSACTION";

export const SAVE_SYSTEM_TRANSACTION_PAGE = "SAVE_SYSTEM_TRANSACTION_PAGE";

//Transactions Token
export const FETCH_TRANSACTION_START = "FETCH_TRANSACTION_START";
export const FETCH_TRANSACTION_END = "FETCH_TRANSACTION_END";
export const SAVE_TRANSACTION_START = "SAVE_TRANSACTION_START";
export const SAVE_TRANSACTION = "SAVE_TRANSACTION";
export const SAVE_STATS_START = "SAVE_STATS_START";
export const SAVE_STATS = "SAVE_STATS";
export const SAVE_TRANSACTION_PAGE = "SAVE_TRANSACTION_PAGE";

export const SAVE_TRANSACTIONS_LIST = "SAVE_TRANSACTIONS_LIST";

export const FETCH_TRANSACTION_START_CAMPAIGN =
  "FETCH_TRANSACTION_START_CAMPAIGN";
export const FETCH_TRANSACTION_END_CAMPAIGN = "FETCH_TRANSACTION_END_CAMPAIGN";
export const SAVE_TRANSACTION_START_CAMPAIGN =
  "SAVE_TRANSACTION_START_CAMPAIGN";
export const SAVE_TRANSACTION_CAMPAIGN = "SAVE_TRANSACTION_CAMPAIGN";
export const SAVE_STATS_START_CAMPAIGN = "SAVE_STATS_START_CAMPAIGN";
export const SAVE_STATS_CAMPAIGN = "SAVE_STATS_CAMPAIGN";
export const SAVE_TRANSACTION_PAGE_CAMPAIGN = "SAVE_TRANSACTION_PAGE_CAMPAIGN";
export const SAVING_CAMPAIGNS = "SAVING_CAMPAIGNS";
export const SAVE_CAMPAIGNS = "SAVE_CAMPAIGNS";

export const SAVE_TOKEN_LIST = "SAVE_TOKEN_LIST";
export const SAVE_TOKEN = "SAVE_TOKEN";
export const SAVE_TOKEN_PAGE = "SAVE_TOKEN_PAGE";

//Campaign
export const SAVING_CAMPAIGN = "SAVING_CAMPAIGN";
export const SAVING_CAMPAIGN_DONE = "SAVING_CAMPAIGN_DONE";
export const SAVING_CAMPAIGN_BOUGHT = "SAVING_CAMPAIGN_BOUGHT";

//History
export const FETCH_HISTORY_START = "FETCH_HISTORY_START";
export const FETCH_HISTORY_END = "FETCH_HISTORY_END";
export const SAVE_HISTORY_START = "SAVE_HISTORY_START";
export const SAVE_HISTORY = "SAVE_HISTORY";
export const SAVE_HISTORY_PAGE = "SAVE_HISTORY_PAGE";

//Route
export const FETCH_ROUTE_START = "FETCH_ROUTE_START";
export const SAVE_ROUTE = "SAVE_ROUTE";
